import * as React from "react";
import { analyticsTracker, classNames, validatePropType } from "../uitk-react-utils/index.js";
export var UitkButtonSize = /* @__PURE__ */ ((UitkButtonSize2) => {
  UitkButtonSize2["SMALL"] = "small";
  UitkButtonSize2["MEDIUM"] = "medium";
  UitkButtonSize2["LARGE"] = "large";
  return UitkButtonSize2;
})(UitkButtonSize || {});
export var UitkButtonTheme = /* @__PURE__ */ ((UitkButtonTheme2) => {
  UitkButtonTheme2["SOLID"] = "solid-btn";
  UitkButtonTheme2["TRANSPARENT"] = "transparent-btn";
  return UitkButtonTheme2;
})(UitkButtonTheme || {});
export class UitkButton extends React.Component {
  static displayName = "UitkButton";
  static defaultProps = {
    isFullWidth: false,
    isDestructive: false,
    size: "medium" /* MEDIUM */
  };
  static baseClassName = "uitk-button";
  render() {
    const { href } = this.props;
    const { size, children, tag, domRef, isFullWidth, isDestructive, className, analytics, style, ...attributes } = this.props;
    const Tag = tag || (href ? "a" : "button");
    const newChildren = [];
    const buttonProps = {
      ...attributes
    };
    if (Tag === "button" && !buttonProps.type) {
      buttonProps.type = "button";
    }
    if (!buttonProps.onTouchStart) {
      buttonProps.onTouchStart = () => {
      };
    }
    const childrenCount = React.Children.toArray(children).length;
    let badge;
    let trailingIcon;
    let leadingIcon;
    let buttonText;
    let a11yText;
    React.Children.forEach(children, (child, index) => {
      const existingClassName = child?.props?.className;
      a11yText = child?.props?.["data-a11ytext"] === "true";
      if (child?.type?.displayName?.includes("UitkNotificationBadge")) {
        badge = React.cloneElement(child, { className: "uitk-button-notification-badge" });
      } else if (child?.type?.displayName === "UitkIcon") {
        leadingIcon = !leadingIcon && index === 0 ? React.cloneElement(child, { className: classNames(existingClassName, "uitk-icon-leading") }) : leadingIcon;
        trailingIcon = !leadingIcon && !trailingIcon && index + 1 === childrenCount ? React.cloneElement(child, { className: classNames(existingClassName, "uitk-icon-trailing") }) : trailingIcon;
      } else if (typeof child === "string" || typeof child?.props?.children === "string" && !a11yText) {
        buttonText = buttonText || child;
      } else {
        newChildren.push(child);
      }
    });
    if (!buttonProps.onClickCapture && analytics) {
      buttonProps.onClickCapture = analyticsTracker.bind(this, analytics);
    }
    const hasIcon = leadingIcon || trailingIcon;
    const onlyIcon = hasIcon && childrenCount === 1 || hasIcon && a11yText && childrenCount === 2;
    const wrapperClassNames = classNames(
      UitkButton.baseClassName,
      {
        [`${UitkButton.baseClassName}-${size}`]: validatePropType(size, UitkButtonSize)
      },
      {
        [`${UitkButton.baseClassName}-fullWidth`]: isFullWidth,
        [`${UitkButton.baseClassName}-destructive`]: isDestructive,
        [`${UitkButton.baseClassName}-has-text`]: buttonText,
        [`${UitkButton.baseClassName}-only-icon`]: onlyIcon
      },
      className
    );
    return /* @__PURE__ */ React.createElement(Tag, { ...buttonProps, className: wrapperClassNames, style, ref: domRef }, badge && !(trailingIcon || leadingIcon) && /* @__PURE__ */ React.createElement(React.Fragment, null, badge), leadingIcon, buttonText, newChildren, trailingIcon);
  }
}
